<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-date-picker
      v-model="date"
      @change="changeDate"

      style="margin-right:15px"
      type="date"
      placeholder="选择日期">
    </el-date-picker>
      <search-dsp-select v-model="tableParams.dspId"/>
      <search-dsp-slot-select v-model="tableParams.dspSlotId" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="downExcel('/webAutoClear/template')"
          type="warning"
          size="mini"
          style="margin-left: 10px"
          >下载模板</el-button
        >

        <el-upload
          :action="$baseURL + 'report/ledger/import/data'"
          :headers="header"
          :show-file-list="false"
          :on-progress="onLoading"
          :on-success="onSuccess"
        >
          <el-button
            v-loading.fullscreen.lock="loading"
            type="primary"
            size="mini"
            style="margin-left: 10px"
            >批量导入</el-button
          >
        </el-upload>
        <el-button
          @click="handleAdd()"
          type="warning"
          size="mini"
          style="margin-left: 10px"
          >新增</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        ref="table"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          :sortable="v.field === 'reportDate'"
          align="center"
        >
          <template v-slot="scope">
            <span>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button @click="handleUpdate(scope.row)" type="primary" size="mini"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, pagination.total]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <m-form @submit="toQuery" ref="form" />
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import { downExcelMixin } from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import { formatDate, PURE_DATE_PATTERN } from '@/util/format'
import mForm from './form'

export default {
  name: 'Manage/account/dspEnter',
  components: {
    TableColumn, mForm, SearchDspSelect, SearchDspSlotSelect
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        { field: 'reportDate', title: '结算时间' },
        { field: 'dspName', title: 'dsp名称' },
        { field: 'dspSlotName', title: 'dsp广告位名称' },
        { field: 'showSmt', title: '展示数' },
        { field: 'clkSmt', title: '点击数' },
        { field: 'income', title: '收入' },
        { field: 'ecpm', title: '收入ecpm' },
        { field: 'createTime', title: '创建时间' },
        { field: 'handlers', title: '创建人' }
      ],
      header: {},
      loading: false,
      date: undefined
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/webAutoClear/list'
      return true
    },
    changeDate () {
      this.tableParams.reportDate = this.date ? formatDate(this.date, PURE_DATE_PATTERN) : this.date
    },
    onLoading () {
      this.loading = true
    },
    onSuccess (res) {
      this.loading = false
      if (res.code === 0) {
        this.$message({
          message: '已成功导入',
          type: 'success'
        })
        this.init()
      }
    },
    handleAdd () {
      this.$refs.form.show()
    },
    handleUpdate (row) {
      this.$refs.form.show(row)
    },
    upAutoData (data) {
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  & > * {
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;
  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}
.tip {
  color: red;
  text-align: center;
  margin-bottom: 20px;
}
</style>
